import React from "react";
import * as Icons from "lucide-react";

/**
 * Render a Lucide icon by string name with premium stroke weight.
 */
export default function ServiceIcon({ name, className = "h-7 w-7" }) {
  const Cmp = Icons[name] || Icons.Heart;
  return <Cmp className={className} strokeWidth={1.5} />;
}
